export default "<figure (click)=\"openHelpDialog()\">\n    <i class=\"far fa-question-circle\"></i>\n    <button>Need help?</button>\n</figure>"